exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".spark-modal__content {\n  max-width: 66.66667%; }\n  .spark-modal__content .spark-modal__footer {\n    padding: 1rem 2rem 2rem 2rem !important;\n    max-width: 100% !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?sourceMap!./src/components/widgets/FileTransportProxy/adapter/FileTransportXHR2.scss
// module id = 1388
// module chunks = 0